import { render } from "./Modal.vue?vue&type=template&id=6c4847dd"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=6c4847dd&scope=true&lang=css"

import exportComponent from "D:\\Work\\renny\\rotto-sale\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__